/* ─── Yester Co Theme JS ────────────────────────────────────────────────────── */

document.addEventListener('DOMContentLoaded', function () {

  // ── Mobile nav toggle ──────────────────────────────────────────────────────
  const hamburger = document.querySelector('.yc-header__hamburger');
  const mobileNav = document.querySelector('.yc-mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
    });
  }

  // ── Homepage hero video ────────────────────────────────────────────────────
  const heroVideo = document.querySelector('.yc-hero__video');
  const motionControl = document.querySelector('.yc-hero__motion-control');
  if (heroVideo && motionControl) {
    const setMotionControl = function (isPlaying) {
      motionControl.textContent = isPlaying ? 'Pause motion' : 'Play motion';
      motionControl.setAttribute('aria-pressed', isPlaying ? 'false' : 'true');
      motionControl.setAttribute('aria-label', isPlaying ? 'Pause hero video' : 'Play hero video');
    };

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      heroVideo.pause();
      setMotionControl(false);
    } else {
      setMotionControl(true);
    }

    motionControl.addEventListener('click', function () {
      if (heroVideo.paused) {
        heroVideo.play();
        setMotionControl(true);
      } else {
        heroVideo.pause();
        setMotionControl(false);
      }
    });
  }

  // ── Before-and-after image comparison ──────────────────────────────────────
  document.querySelectorAll('.yc-compare').forEach(function (comparison) {
    const range = comparison.querySelector('.yc-compare__range');
    if (!range) return;
    const updateComparison = function () {
      comparison.style.setProperty('--yc-compare-position', range.value + '%');
    };
    range.addEventListener('input', updateComparison);
    updateComparison();
  });

  // ── Product gallery ────────────────────────────────────────────────────────
  const mainImg = document.querySelector('.yc-gallery__main');
  const thumbs  = document.querySelectorAll('.yc-gallery__thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImg) {
        mainImg.src = thumb.dataset.src;
        mainImg.alt = thumb.dataset.alt || mainImg.alt;
      }
      thumbs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-pressed', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-pressed', 'true');
    });
  });

  // ── Image lightbox (zoom on click) ────────────────────────────────────────
  (function () {
    // Create lightbox overlay once
    var overlay = document.createElement('div');
    overlay.id = 'yc-lightbox';
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-label', 'Image zoom');
    overlay.innerHTML =
      '<button id="yc-lightbox__close" aria-label="Close">&times;</button>' +
      '<img id="yc-lightbox__img" src="" alt="" />';
    document.body.appendChild(overlay);

    var lbImg   = document.getElementById('yc-lightbox__img');
    var lbClose = document.getElementById('yc-lightbox__close');

    function openLightbox(src, alt) {
      lbImg.src = src;
      lbImg.alt = alt || '';
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    // Wire up every .yc-gallery__main image (handles multiple galleries on page)
    document.querySelectorAll('.yc-gallery__main').forEach(function (img) {
      img.addEventListener('click', function () {
        // Use the full-res src already loaded in the img tag
        openLightbox(img.src, img.alt);
      });
    });

    // Close on overlay click (outside image) or close button
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target === lbClose) closeLightbox();
    });

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });
  }());

  // ── Product tabs ───────────────────────────────────────────────────────────
  const tabBtns   = document.querySelectorAll('.yc-tabs__tab');
  const tabPanels = document.querySelectorAll('.yc-tabs__panel');
  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const target = btn.dataset.tab;
      tabBtns.forEach(function (b) { b.classList.remove('is-active'); });
      tabPanels.forEach(function (p) { p.classList.remove('is-active'); });
      btn.classList.add('is-active');
      const panel = document.querySelector('.yc-tabs__panel[data-tab="' + target + '"]');
      if (panel) panel.classList.add('is-active');
    });
  });

  // ── FAQ accordion ──────────────────────────────────────────────────────────
  const faqItems = document.querySelectorAll('.yc-faq__item');
  faqItems.forEach(function (item) {
    const btn = item.querySelector('.yc-faq__question');
    if (btn) {
      btn.addEventListener('click', function () {
        const isOpen = item.classList.contains('is-open');
        faqItems.forEach(function (i) { i.classList.remove('is-open'); });
        if (!isOpen) item.classList.add('is-open');
      });
    }
  });

  // ── Add-on checkbox + dynamic total ───────────────────────────────────────
  // NOTE: The pre-order buttons use inline onclick handlers defined in the
  // section Liquid files (addToCartWithUpsell / addToCartAndRedirect).
  // Do NOT attach additional click listeners here — that causes double-adds.
  const addonCheckbox = document.getElementById('addon-tray');
  const totalDisplay  = document.getElementById('yc-total-price');
  const ctaPrice      = document.getElementById('yc-cta-price');

  var BASE_PRICE  = 380;
  var ADDON_PRICE = 89;

  function updateTotal() {
    var total = BASE_PRICE + (addonCheckbox && addonCheckbox.checked ? ADDON_PRICE : 0);
    var formatted = '$' + total;
    if (totalDisplay) totalDisplay.textContent = formatted;
    if (ctaPrice) ctaPrice.textContent = formatted;
  }

  if (addonCheckbox) {
    addonCheckbox.addEventListener('change', updateTotal);
    updateTotal();
  }

  // ── Addon label click ──────────────────────────────────────────────────────
  const addonRow = document.querySelector('.yc-addon');
  if (addonRow && addonCheckbox) {
    addonRow.addEventListener('click', function (e) {
      if (e.target !== addonCheckbox) {
        addonCheckbox.checked = !addonCheckbox.checked;
        addonCheckbox.dispatchEvent(new Event('change'));
      }
    });
  }

});
